export const messages = {
  en: {
    roomStructure: {
      page: {
        title: 'Room Structure',
        subtitle: 'Visual overview of room occupancy and arrears by unit'
      },
      structureTitle: 'Building / Unit',
      legend: {
        title: 'Legend',
        debt: 'Arrears',
        noOwner: 'No Owner',
        occupied: 'Occupied',
        handOver: 'Handed Over',
        other: 'Other'
      },
      noOwner: 'None',
      owe: 'Debt',
      yuan: 'Yuan',
      searchPlaceholder: 'Please enter room number like 1-1-1',
      building: 'Building',
      unit: 'Unit'
    }
  },
  zh: {
    roomStructure: {
      page: {
        title: '房屋结构图',
        subtitle: '按单元查看房屋入住状态与欠费情况'
      },
      structureTitle: '楼栋 / 单元',
      legend: {
        title: '图例',
        debt: '欠费',
        noOwner: '无业主',
        occupied: '已入住',
        handOver: '已交房',
        other: '其他状态'
      },
      noOwner: '无',
      owe: '欠费',
      yuan: '元',
      searchPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1',
      building: '栋',
      unit: '单元'
    }
  }
}
